module.exports = __webpack_public_path__ + "img/ico_template.33509030.svg";